import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'availablePrograms');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'provider_patient_programs',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/availablePrograms.js